<template>
  <div>
    <div v-if="activeEvents.length > 0" class="upcoming-events-title">
      {{activeEventsTitle}}
    </div>
    <div class="event-cards">
      <event-card v-for="event in activeEvents" :key="event._id"
        :eventId="event._id"
        :title="event.title"
        :pic="event.pic"
        :minPricingPackage="event.minPricingPackage"
        :startDate="event.startDate"
        :location="event.isOnline ? 'Online Event' : event.location.title"
        :category="event.category"
        :team="event.team"
      />
    </div>
    <div v-if="pastEvents.length > 0" class="event-cards-past">
      <div class="past-events-title">Past Events</div>
      <div class="event-cards">
        <event-card v-for="event in pastEvents" :key="event._id"
          :eventId="event._id"
          :title="event.title"
          :pic="event.pic"
          :minPricingPackage="event.minPricingPackage"
          :startDate="event.startDate"
          :location="event.isOnline ? 'Online Event' : event.location.title"
          :category="event.category"
          :team="event.team"
        />
      </div>
    </div>
  </div>
</template>

<script>
import EventCard from '@/components/event/view/EventCard.vue';

export default {
  name: 'EventCards',
  components: {
    EventCard,
  },
  props: {
    events: {
      type: Array,
      default: () => [],
    },
    activeEventsTitle: {
      type: String,
      default: 'Upcoming Events',
    },
  },
  computed: {
    activeEvents() {
      return this.events.filter(({ status }) => status === 'active');
    },
    pastEvents() {
      return this.events.filter(({ status }) => status === 'past');
    },
  },
};
</script>

<style lang="scss" scoped>

.upcoming-events-title, .past-events-title {
  margin-left: 0.5rem;
  font-size: 1.5rem;
  font-weight: 600;
}

.upcoming-events-title{
  margin-top: 1rem;
}

.event-cards-past {
  border-top: 0.1rem solid #eaeaea;
}

.past-events-title {
  margin-top: 1rem;
}

.event-cards {
  width: 100%;
  // top: 110vh;
  justify-content: center;
  text-decoration: none;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  grid-column-gap: 0.5rem;
  grid-row-gap: 0.5rem;
  margin: 1rem auto;
  font-size: 1rem;
}

.event-cards a {
  color:#333333;
  text-decoration: none;
}

</style>
